import { surveyResultApi } from "api/projectlearning.api";
import { SurveyResultSaveAsCompletedRequestDto } from "model/pl-api";
import { appInsights } from "utils/logging/appInsights";

export const saveSurveyAsCompleted = async (
  requestDto: SurveyResultSaveAsCompletedRequestDto
) => {
  try {
    let x = await surveyResultApi.saveSurveyAsCompleted(requestDto);
  } catch (error: any) {
    console.log(error);
      const additionalProperties = {
      "ApplicationName": "Client App",
      "Request": "saveSurveyAsCompleted",
      "Error": error
    };
    appInsights.trackException({exception: new Error(error)}, additionalProperties);
  }
};
